import LocationPageTemplate from '../components/LocationPageTemplate';
export default function RockvillePage() { return <LocationPageTemplate locationSlug="rockville" />; }
